import React, { Component } from "react";
import Proptypes from "prop-types";
import Slider from "react-slick";
import { Helmet } from "react-helmet";
import { SliderWrapper } from "./style";

class ImageTextCarousel extends Component {
	render() {
		const settings = {
			dots: true,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 5000,
			fade: true,
			speed: 500,
		};

		return (
			<div>
				<Helmet>
					<link
						rel="stylesheet"
						type="text/css"
						charset="UTF-8"
						href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
					/>
					<link
						rel="stylesheet"
						type="text/css"
						href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
					/>
				</Helmet>
				<SliderWrapper>
					<Slider {...settings}>
						{this.props.images.map((image, index) => {
							return (
								<div key={index}>
									<div className="heading">{image.heading}</div>
									<img className="image" src={image.image.image} />
									<div className="content">{image.description}</div>
									<div className="userName">{image.name}</div>
									<div className="role">{image.job_role}</div>
								</div>
							);
						})}
					</Slider>
				</SliderWrapper>
			</div>
		);
	}
}

ImageTextCarousel.propTypes = {
	image: Proptypes.array,
};

ImageTextCarousel.defaultProps = {
	image: [],
};

export default ImageTextCarousel;
